import { DATA_TYPES } from '../CommonConstants';
import {
  INTEGRATION_CRITERIA_TYPE,
  INTEGRATION_SETTING_TYPE,
  INTEGRATION_SYNC_TYPE,
  INTEGRATION_TYPE,
} from '../IntegrationConstants';

/* eslint-disable no-use-before-define */
export const CRITERIA = {
  CREATE: 'create',
  UPDATE: 'update',
  CHURN: 'churn',
  ARCHIVE: 'archive',
};

export const CONTACT_CRITERIA = {
  CREATE: 'create',
  UPDATE: 'update',
};
export const SYNC_DIRECTION = {
  IN: 'into',
  OUT: 'out',
};

export const SIDE_NAV_BAR_OPTIONS = {
  DEDUPLICATION: 'deduplication',
  PARENT_LINK: 'customParentLinkDeduplication',
  CREATE: 'create',
  UPDATE: 'update',
  CHURN: 'churn',
  ARCHIVE: 'archive',
  IN_SYNC: 'inSync',
};

export const CONFIG_STATUS_LEVEL = {
  NOT_STARTED: 0, // not started
  IN_PROGRESS: 1, // started to edit
  COMPLETED: 2, // completed in UI
  SAVED: 3, // persisted in database
};

export const CONFIG_TYPES = {
  DEDUPLICATION: 'deduplication',
  PARENT_LINK: 'customParentLinkDeduplication',
  OBJECT_TYPE: 'objectType',
  CONDITIONS: 'conditions',
  DATA_MAPPING: 'dataMapping',
  IN_SYNC: 'inSync',
  NOTE_SYNC: 'noteSync',
  ACTIVITY_SYNC: 'activitySync',
  PARENT_LINK_CREATE: 'linkParentCreate',
  DEDUPLICATION_UPDATE: 'deduplicationUpdate',
  ADDITIONAL_DEDUPLICATION: 'additionalDeduplication',
  DAILY_SYNC_RECORD_ID_MAPPING: 'dailySyncRecordIdMapping',
};

export const ENTITY_HEADER_MAP = {
  organization: { id: 'org', name: 'Organizations' },
  account: { id: 'acc', name: 'Accounts' },
  contact: { id: 'contacts', name: 'Contacts' },
  activity: { id: 'activities', name: 'Activities' },
  note: { id: 'notes', name: 'Notes' },
};

export const NOTE_HEADER_MAP = {
  organization: { id: 'org', name: 'Organizations' },
  account: { id: 'acc', name: 'Accounts' },
};

export const ENTITY_LEVEL = {
  ORGANIZATION: 'organization',
  ACCOUNT: 'account',
  CONTACT: 'contact',
  ACTIVITY: 'activity',
  ALL: 'all',
  NOTE: 'note',
};

export const CRITERIA_STEPS = {
  step1: { order: 1, name: 'Choose Object Type' },
  step2: { order: 2, name: 'Set Criteria' },
  step3: { order: 3, name: 'Field Mapping' },
};

export const STEP_BUILDER_MAP = {
  1: CONFIG_TYPES.OBJECT_TYPE,
  2: CONFIG_TYPES.CONDITIONS,
  3: CONFIG_TYPES.DATA_MAPPING,
};

export const DATA_MAPPING_TYPES = {
  DATA_MAPPING: 'dataMapping',
  DEDUPLICATION: 'deduplication',
  DATA_MAPPING_VELARIS: 'dataMappingVelaris',
  IN_SYNC_DATA_MAPPING: 'entityInSync',
  DEAL_PRIMARY_COMPANY: 'linkPrimaryCompany',
  PARENT_COMPANY: 'linkParentCompany',
  LINKED_PROPERTY: 'linkCustomAttribute',
  DAILY_SYNC_RECORD_ID_MAPPING: 'dailySyncRecordIdMapping',
};

export const PARENT_LINK_TYPE = {
  DEAL_PRIMARY_COMPANY: 'dealPrimaryCompany',
  PARENT_OF_LINKED_COMPANY: 'parentOfLinkedCompany',
  LINKED_PROPERTY: 'linkedProperty',
};

export const PARENT_LINK_MAPPING = {
  [DATA_MAPPING_TYPES.DEAL_PRIMARY_COMPANY]:
    PARENT_LINK_TYPE.DEAL_PRIMARY_COMPANY,
  [DATA_MAPPING_TYPES.PARENT_COMPANY]:
    PARENT_LINK_TYPE.PARENT_OF_LINKED_COMPANY,
  [DATA_MAPPING_TYPES.LINKED_PROPERTY]: PARENT_LINK_TYPE.LINKED_PROPERTY,
};

export const COMMON_PIPELINE_STAGES = {
  ANY: 'any',
};

export const CRM_DATA_TYPES = {
  STRING: 'string',
  BOOLEAN: 'boolean',
  NUMBER: 'number',
  DATE: 'date',
  CALCULATED: 'calculated',
  ORGANIZATION: 'organization',
  ACCOUNT: 'account',
  CONTACT: 'contact',
  USER: 'user',
  SINGLEPICKLIST: 'singlePicklist',
  MULTIPICKLIST: 'multiPicklist',
  CURRENCY: 'currency',
  COMPANY: 'company',
  ASSOCIATION_LABEL: 'associationLabel',
};

export const CRM_FIELD_MAPPING_TEMPLATE = {
  dataMappings: {
    0: {
      dataMappingId: 0,
      velaris: {},
      crm: {},
      crmPropertyType: {},
      status: CONFIG_STATUS_LEVEL.NOT_STARTED,
      fieldConfig: null,
    },
  },
  status: CONFIG_STATUS_LEVEL.NOT_STARTED,
};

export const CRM_CONDITION_TEMPLATE = {
  conditions: {
    A: {
      conditionName: 'A',
      stageFrom: [],
      stageTo: [],
      properties: {},
    },
  },
  status: CONFIG_STATUS_LEVEL.NOT_STARTED,
};

export const CRM_DEDUPLICATION_TEMPLATE = {
  status: CONFIG_STATUS_LEVEL.NOT_STARTED,
  velaris: {},
  crm: {},
  crmPropertyType: {},
};

export const CRM_PARENT_LINKING_TEMPLATE = {
  dataMappingId: 0,
  velaris: {},
  crm: {},
  criteria: INTEGRATION_CRITERIA_TYPE.ALL,
  type: null,
  status: CONFIG_STATUS_LEVEL.NOT_STARTED,
};

export const CRM_VENDOR_NAMES = {
  hubspot: 'HubSpot',
};

export const FIELD_MAPPING_OUT_DESCRIPTION = {
  create:
    'Create new Companies in HubSpot when entities are created in Velaris',
  update:
    'Update Companies / Deals in HubSpot when entities are updated in Velaris',
  churn:
    'Update Companies / Deals in HubSpot when entities are Churned in Velaris',
  archive:
    'Archive Companies/ Deals in HubSpot when entities are Archived in Velaris',
};

export const FIELD_MAPPING_OUT_DESCRIPTION_CONTACT = {
  create:
    'Create new Contacts in HubSpot when Contacts are created and linked to an Entity in Velaris (an Organization or an Account) which is also existing as a Company or a Deal in Hubspot',
  update:
    'Update Contacts in HubSpot when the same Contacts are updated in Velaris',
};
export const CRM_FILTER_TEMPLATE = {
  filters: {},
  status: CONFIG_STATUS_LEVEL.NOT_STARTED,
};

export const IN_SYNC_CONDITION_OPTIONS = [
  { value: 'isEqualTo', label: 'Is equal to' },
  { value: 'isNotEqualTo', label: 'Is not equal to' },
];

export const ALLOWED_VELARIS_DATA_TYPES = [
  DATA_TYPES.string,
  DATA_TYPES.boolean,
  DATA_TYPES.number,
  DATA_TYPES.date,
  DATA_TYPES.organization,
  DATA_TYPES.account,
  DATA_TYPES.contact,
  DATA_TYPES.user,
  DATA_TYPES.singlePicklist,
  DATA_TYPES.multiPicklist,
  DATA_TYPES.currency,
  DATA_TYPES.organizationPicklist,
  DATA_TYPES.accountPicklist,
  DATA_TYPES.contactPicklist,
  DATA_TYPES.userPicklist,
];

export const ALLOWED_PUSH_BACK_VELARIS_DATA_TYPES = [
  DATA_TYPES.string,
  DATA_TYPES.boolean,
  DATA_TYPES.number,
  DATA_TYPES.date,
  DATA_TYPES.organization,
  DATA_TYPES.account,
  DATA_TYPES.contact,
  DATA_TYPES.user,
  DATA_TYPES.singlePicklist,
  DATA_TYPES.multiPicklist,
  DATA_TYPES.currency,
];

export const CRM_NOTE_SYNC_TEMPLATE = {
  noteSync: false,
  status: CONFIG_STATUS_LEVEL.NOT_STARTED,
};

export const CRM_PARENT_LINK_STATUS_TEMPLATE = {
  linkParentType: null,
  entityLevel: 'account',
  settingType: 'linkParent',
  integrationType: 'crm',
  criteria: null,
  syncDirection: 'vendorToVelaris',
  enable: 0,
  status: CONFIG_STATUS_LEVEL.NOT_STARTED,
};

export const CRM_PARENT_CREATE_TEMPLATE = {
  enable: 0,
  status: CONFIG_STATUS_LEVEL.NOT_STARTED,
};

export const CRM_DEDUPLICATION_UPDATE_TEMPLATE = {
  enable: 0,
  status: CONFIG_STATUS_LEVEL.NOT_STARTED,
};

export const CRM_TOGGLE_TEMPLATE = {
  enable: 0,
  status: CONFIG_STATUS_LEVEL.NOT_STARTED,
};

export const PROPERTY_TYPE = {
  COMPANY: 'company',
  CONTACT: 'contact',
  DEAL: 'deal',
};

export const COMMON_SYNC_DIRECTION = {
  IN: 'vendorToVelaris',
  OUT: 'velarisToVendor',
};

export const HS_RECORD_ID = 'hs_object_id';

export const CRM_CONFIG_INITIAL_STATE = {
  entityInSyncOrganizationDataDrivenNa: 0,
  entityInSyncAccountDataDrivenNa: 0,
  entityInSyncContactDataDrivenNa: 0,
  dealBasedTriggerOrganizationEventDrivenCreate: 0,
  dealBasedTriggerOrganizationEventDrivenUpdate: 0,
  dealBasedTriggerOrganizationEventDrivenArchive: 0,
  dealBasedTriggerOrganizationEventDrivenChurn: 0,
  dealBasedTriggerAccountEventDrivenCreate: 0,
  dealBasedTriggerAccountEventDrivenUpdate: 0,
  dealBasedTriggerAccountEventDrivenArchive: 0,
  dealBasedTriggerAccountEventDrivenChurn: 0,
  dealBasedTriggerContactEventDrivenCreate: 0,
  linkParentAccountEventDrivenCreate: 0,
  linkParentAccountEventDrivenUpdate: 0,
  linkParentAccountEventDrivenNa: 0,
  pushBackOrganizationNaCreate: 0,
  pushBackOrganizationNaUpdate: 0,
  pushBackOrganizationNaArchive: 0,
  pushBackOrganizationNaChurn: 0,
  pushBackAccountNaCreate: 0,
  pushBackAccountNaUpdate: 0,
  pushBackAccountNaArchive: 0,
  pushBackAccountNaChurn: 0,
  pushBackContactNaCreate: 0,
  pushBackContactNaUpdate: 0,
  deduplicationUpdateContactNaNa: 0,
  additionalDeduplicationAccountAllNa: 0,
  additionalDeduplicationOrganizationAllNa: 0,
  loading: false,
  error: null,
};

export const CRM_DEFAULT_OBJ_BASED_ON_ENTITY = {
  [ENTITY_LEVEL.ORGANIZATION]: PROPERTY_TYPE.COMPANY,
  [ENTITY_LEVEL.ACCOUNT]: PROPERTY_TYPE.COMPANY,
  [ENTITY_LEVEL.CONTACT]: PROPERTY_TYPE.CONTACT,
};

export const LINK_PARENT_ORGANIZATION_TYPE = {
  DEAL_PRIMARY_COMPANY: 'dealPrimaryCompany',
  PARENT_OF_LINKED_COMPANY: 'parentOfLinkedCompany',
  LINKED_PROPERTY: 'linkedProperty',
};

export const RESERVED_ACTIVITY_TYPES_LOOKUP = {
  1: {
    id: 1,
    displayName: 'General',
  },
};

export const CRM_ACTIVITY_TYPE_TEMPLATE = {
  integrationType: INTEGRATION_TYPE.CRM,
  entityLevel: ENTITY_LEVEL.ALL,
  settingType: INTEGRATION_SETTING_TYPE.ACTIVITY_SYNC,
  syncDirection: COMMON_SYNC_DIRECTION.IN,
  syncType: INTEGRATION_SYNC_TYPE.EVENT_DRIVEN,
};

export const CRM_ACTIVITY_SYNC_CONFIG_KEYS = {
  SYNC_STATUS: 'syncStatus',
  HISTORICAL_SYNC: 'historicalSync',
  DAILY_SYNC: 'dailySync',
  SYNC_TYPE: 'syncType',
};

export const CRM_ACTIVITY_SYNC_DEFAULT_CONFIG = {
  [CRM_ACTIVITY_SYNC_CONFIG_KEYS.SYNC_STATUS]: false,
  [CRM_ACTIVITY_SYNC_CONFIG_KEYS.HISTORICAL_SYNC]: true,
  [CRM_ACTIVITY_SYNC_CONFIG_KEYS.DAILY_SYNC]: true,
  [CRM_ACTIVITY_SYNC_CONFIG_KEYS.SYNC_TYPE]: INTEGRATION_CRITERIA_TYPE.UPDATE,
};

export const CRM_CURRENCY_TYPES = {
  RECORD_CURRENCY: 'record_currency',
  COMPANY_CURRENCY: 'company_currency',
};

export const SYNC_DIRECTION_MAP = {
  [SYNC_DIRECTION.IN]: COMMON_SYNC_DIRECTION.IN,
  [SYNC_DIRECTION.OUT]: COMMON_SYNC_DIRECTION.OUT,
};

export const ENTITY_SYNC_STATUS = {
  NOT_STARTED: 0,
  STARTED: 1,
  IN_PROGRESS: 2,
  COMPLETED: 3,
};
